<script setup lang="ts">

import CarbucksProtectFeatures from './Components/CarbucksProtectFeatures.vue';

</script>

<template>

    <Page>
   
        <div class="grid grid-cols-1 lg:grid-cols-3 justify-center items-center gap-4 2xl:gap-16 -my-6">

            <div class="flex flex-col items-center gap-4 pt-6 order-1">
            
                <Image src="/ConsumerProposition/carbucks-protect-logo.png"
                    class="w-3/5" 
                />

                <div class="text-center text-sm 2xl:text-base font-semibold uppercase 
                            text-white/50 px-8">
                    3-year Program
                </div>

                <Image
                    src="/images/shared/WhatIsCarbucks/carbucks-protect.png"
                    class="w-[50vw] md:w-full max-w-[420px] mb-6 mx-auto 2xl:-top-4 2xl:-mb-2"
                    floor-shadow
                />

                <Video 
                    class="-mt-12"
                    src="~/video/protect.mp4" 
                    title="Watch Video" 
                />

            </div>

            <div class="col-span-1 lg:col-span-2 flex flex-col items-center 2xl:-top-4 3xl:-top-6">
                <CarbucksProtectFeatures />
                <div class="mt-4 text-xs 2xl:text-base">+ includes Carbucks REWARDS</div>
            </div>

        </div>

        <KeyMessage animation="push-up">
            <div class="pt-4 2xl:pt-0 2xl:text-2xl">
                Customers return to the dealership to have the repairs completed
            </div>
        </KeyMessage>

    </Page>

</template>